import { styled, MenuItem, Select } from '@mui/material';
import { useLayoutContext } from 'contexts/LayoutContext';

const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: `${theme.palette.common.brandColor}15`,
  color: theme.palette.common.brandColor,
  fontWeight: 600,

  '&:hover': {
    '& fieldset': {
      borderColor: `${theme.palette.common.brandColor}40 !important`,
    },
  },

  '& fieldset': {
    borderColor: `${theme.palette.common.brandColor}15`,
  },
}));

const VehicleSwitcher: React.FC = () => {
  const { selectedVehicleId, switchVehicle, availableVehicles } =
    useLayoutContext();

  return (
    <StyledSelect
      fullWidth
      value={selectedVehicleId}
      onChange={(e) => {
        const newVehicleId = e.target.value as string;
        switchVehicle(newVehicleId);
      }}
    >
      {availableVehicles.map((vehicle) => (
        <MenuItem key={vehicle._id} value={vehicle._id}>
          {vehicle.vehicleName}
        </MenuItem>
      ))}
    </StyledSelect>
  );
};

export default VehicleSwitcher;
